import { createStore, Provider } from 'jotai';
import { type ReactNode } from 'react';

export const filterListBottomSheetStore = createStore();

/**
 * - FILTER_LIST atomic을 사용하기 위해 필요한 provider
 */
export const FilterListBottomSheetAtomProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <Provider store={filterListBottomSheetStore}>{children}</Provider>;
};
